module.exports = __webpack_public_path__ + "Icon_Organization.97a9c4396dafb15495b5.png";